var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_4940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8412 2.99365H3.25453C2.77957 2.99365 2.39453 3.37869 2.39453 3.85365V13.807C2.39453 14.2819 2.77957 14.667 3.25453 14.667H10.8412C11.3162 14.667 11.7012 14.2819 11.7012 13.807V3.85365C11.7012 3.37869 11.3162 2.99365 10.8412 2.99365Z",
    stroke: "#A0A0A0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30078 2.08613C4.30078 1.88633 4.38015 1.69472 4.52143 1.55344C4.6627 1.41216 4.85432 1.33279 5.05411 1.33279H12.8541C12.9533 1.3319 13.0517 1.35078 13.1435 1.38833C13.2353 1.42587 13.3187 1.48133 13.3888 1.55146C13.4589 1.62159 13.5144 1.70499 13.5519 1.79679C13.5895 1.88859 13.6083 1.98695 13.6074 2.08613V12.2528C13.6074 12.4526 13.5281 12.6442 13.3868 12.7855C13.2455 12.9268 13.0539 13.0061 12.8541 13.0061",
    stroke: "#A0A0A0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_4940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.24095531e10bdfa87de1449728bcc69e.svg";
export { ForwardRef as ReactComponent };